import { type ReactNode, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SupplierLogo } from '@/components/resultList/images/SupplierLogo';
import type { PaleState, ThunkDispatchFunc } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { type CheckboxDispatchProps, CheckboxFilter } from './CheckboxFilter';

type NonCharterSupplierFilterProps = {
    onFilterChange: () => void;
};

export const NonCharterSupplierFilter = ({ onFilterChange }: NonCharterSupplierFilterProps) => {
    const dispatch = useDispatch<ThunkDispatchFunc>();

    const facetList = useSelector((s: PaleState) => s.results.facets.nonCharterSuppliers);
    const checkboxValues = useSelector((s: PaleState) => s.filters.suppliers);

    const displayValues = useMemo<Record<string, ReactNode>>(
        () => Object.fromEntries((facetList ?? []).map((s) => [s.value, <SupplierLogo key={s.value} supplier={s.value} />])),
        [facetList],
    );

    const hasOptions = Array.isArray(facetList) && facetList.length > 0;

    const checkBoxClick: CheckboxDispatchProps['checkBoxClick'] = (valueOrMap) => {
        dispatch(actions.filterCheckboxSupplier(valueOrMap));
    };

    return hasOptions ? (
        <CheckboxFilter
            id="nonCharterSupplierFilter"
            label="Fly + Hotell"
            facetList={facetList}
            displayValues={displayValues}
            checkboxValues={checkboxValues}
            checkBoxClick={checkBoxClick}
            fetchResults={onFilterChange}
        />
    ) : null;
};
